'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _templateObject = _taggedTemplateLiteral(['\n    position: relative;\n'], ['\n    position: relative;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    padding: ', ';\n    border: ', ';\n    border-radius: 4px;\n    background-color: white;\n    box-sizing: border-box;\n    width: 100%;\n'], ['\n    padding: ', ';\n    border: ', ';\n    border-radius: 4px;\n    background-color: white;\n    box-sizing: border-box;\n    width: 100%;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    margin-top: 1rem;\n'], ['\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    margin-top: 1rem;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: absolute;\n    cursor: pointer;\n    top: 68px;\n    right: -34px;\n'], ['\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: absolute;\n    cursor: pointer;\n    top: 68px;\n    right: -34px;\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    cursor: pointer;\n'], ['\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    cursor: pointer;\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n    width: 118%;\n    border: 1px solid ', ';\n    margin-left: -9%;\n'], ['\n    width: 118%;\n    border: 1px solid ', ';\n    margin-left: -9%;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _metrixCommon = require('metrix-common');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Component = require('../../Component');

var _Component2 = _interopRequireDefault(_Component);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _tableHeader = require('./tableHeader');

var _tableHeader2 = _interopRequireDefault(_tableHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var TableArea = _styledComponents2.default.div(_templateObject);

var TableContainer = _styledComponents2.default.div(_templateObject2, function (_ref) {
    var recursive = _ref.recursive;
    return recursive ? '0' : function (_ref2) {
        var mobile = _ref2.mobile,
            tablet = _ref2.tablet,
            desktop = _ref2.desktop;
        return mobile && '1rem' || tablet && '1.5rem 3rem 1.5rem' || desktop && '1.5rem 3rem 1.5rem';
    };
}, function (_ref3) {
    var recursive = _ref3.recursive,
        isErrors = _ref3.isErrors;
    return recursive ? 'none' : '1px solid ' + (isErrors ? _metrixCommon.Colors.Error : _metrixCommon.Colors.StrokeDark);
});

var TableContent = _styledComponents2.default.div(_templateObject3);

var DeleteButton = _styledComponents2.default.div(_templateObject4);

var AddButtonContainer = _styledComponents2.default.div(_templateObject5);

var Divider = _styledComponents2.default.hr(_templateObject6, _metrixCommon.Colors.StrokeMedium);

var WorkflowTable = function WorkflowTable(_ref4) {
    var entity = _ref4.entity,
        component = _ref4.component,
        valid = _ref4.valid,
        reference = _ref4.reference,
        context = _ref4.context,
        doSetReturn = _ref4.doSetReturn,
        doReduceDynamicDate = _ref4.doReduceDynamicDate,
        doStep = _ref4.doStep,
        configuration = _ref4.configuration,
        session = _ref4.session,
        culture = _ref4.culture,
        dotProp = _ref4.dotProp,
        returns = _ref4.returns,
        index = _ref4.index,
        isExpanded = _ref4.isExpanded,
        setIsExpanded = _ref4.setIsExpanded,
        mobile = _ref4.mobile,
        tablet = _ref4.tablet,
        desktop = _ref4.desktop,
        recursive = _ref4.recursive,
        shouldRenderChild = _ref4.shouldRenderChild,
        setShouldRenderChild = _ref4.setShouldRenderChild,
        props = _objectWithoutProperties(_ref4, ['entity', 'component', 'valid', 'reference', 'context', 'doSetReturn', 'doReduceDynamicDate', 'doStep', 'configuration', 'session', 'culture', 'dotProp', 'returns', 'index', 'isExpanded', 'setIsExpanded', 'mobile', 'tablet', 'desktop', 'recursive', 'shouldRenderChild', 'setShouldRenderChild']);

    var _React$useState = _react2.default.useState(null),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        showModal = _React$useState2[0],
        setShowModal = _React$useState2[1];

    var isColumns = component.components.find(function (el) {
        return el.type === 'columns';
    });
    var columnDefinition = isColumns && component.components.find(function (el) {
        return el.type === 'columns';
    }).components;
    var columnObject = props.return && props.return.elements.find(function (el) {
        return el.code === 'Columns';
    });
    var columnsData = Boolean(columnObject) && columnObject.elements;
    var columnsDataIndex = props.return && props.return.elements.indexOf(columnObject);
    var tableDefinition = component.components.find(function (el) {
        return el.type === 'table';
    });

    var tableObject = props.return && props.return.elements.find(function (el) {
        return el.code === 'Entities';
    });
    var tableData = tableObject ? tableObject.elements : [];
    var tableDataIndex = props.return && props.return.elements.indexOf(tableObject);
    var isRules = component.elements.find(function (el) {
        return el.code === 'Rules';
    });

    var rules = isRules && component.elements.find(function (el) {
        return el.code === 'Rules';
    }).elements;
    var allowAdd = isRules && rules.find(function (el) {
        return el.code === 'AllowAdd';
    }) && rules.find(function (el) {
        return el.code === 'AllowAdd';
    }).value === 'true';
    var allowDelete = isRules && rules.find(function (el) {
        return el.code === 'AllowDelete';
    }) && rules.find(function (el) {
        return el.code === 'AllowDelete';
    }).value === 'true';
    var maxCount = isRules && rules.find(function (el) {
        return el.code === 'MaxCount';
    }) && Number(rules.find(function (el) {
        return el.code === 'MaxCount';
    }).value);
    var isCollapsible = isRules && rules.find(function (el) {
        return el.code === 'IsCollapsible';
    }) && rules.find(function (el) {
        return el.code === 'IsCollapsible';
    }).value === 'true';
    var dependencies = isRules && rules.find(function (el) {
        return el.code === 'Dependencies';
    }) && rules.find(function (el) {
        return el.code === 'Dependencies';
    }).elements;
    var isDynamicRules = props.return && props.return.elements.find(function (el) {
        return el.code === 'Rules';
    });
    var errors = isDynamicRules && isDynamicRules.elements.find(function (el) {
        return el.code === 'Errors';
    }) && isDynamicRules.elements.find(function (el) {
        return el.code === 'Errors';
    }).elements;

    var dynamicRules = isDynamicRules && isDynamicRules.elements;
    var preDefinedValues = isDynamicRules && dynamicRules.find(function (el) {
        return el.code === 'PreDefinedValues';
    }) && dynamicRules.find(function (el) {
        return el.code === 'PreDefinedValues';
    }).elements;
    var addButtonLabel = isRules && rules.find(function (el) {
        return el.code === 'AddButtonLabel';
    }) && rules.find(function (el) {
        return el.code === 'AddButtonLabel';
    }).value;

    var modalDeleteHeader = isRules && rules.find(function (el) {
        return el.code === 'ModalDeleteHeader';
    }) && rules.find(function (el) {
        return el.code === 'ModalDeleteHeader';
    }).value;
    var modalDeleteSubHeader = isRules && rules.find(function (el) {
        return el.code === 'ModalDeleteSubHeader';
    }) && rules.find(function (el) {
        return el.code === 'ModalDeleteSubHeader';
    }).value;
    var expandHandler = function expandHandler() {
        return isExpanded === index ? setIsExpanded(null) : setIsExpanded(index);
    };

    var isCollapsed = isExpanded !== index;

    var checkIsHidden = function checkIsHidden(columnDefinition) {
        var isHidden = false;

        if (!columnDefinition || !Array.isArray(columnDefinition.elements)) return isHidden;

        isHidden = columnDefinition.elements.find(function (el) {
            return el.code === 'IsHidden';
        }) && columnDefinition.elements.find(function (el) {
            return el.code === 'IsHidden';
        }).value === 'true';

        if (dependencies && dependencies.length > 0) {
            var code = columnDefinition.hasOwnProperty('legacyCode') ? columnDefinition.legacyCode : columnDefinition.code;
            var dependency = dependencies.find(function (dependency) {
                return dependency.code === code;
            });
            var runtimeDependencies = dependency && dependency.elements.find(function (el) {
                return el.code === 'RunTimeValues';
            }) && dependency.elements.find(function (el) {
                return el.code === 'RunTimeValues';
            }).elements;
            var predefinedDependencies = dependency && dependency.elements.find(function (el) {
                return el.code === 'PreDefinedValues';
            }) && dependency.elements.find(function (el) {
                return el.code === 'PreDefinedValues';
            }).elements;

            if (predefinedDependencies && predefinedDependencies.length > 0 && preDefinedValues && preDefinedValues.length > 0) {
                var _loop = function _loop(preDefDep) {
                    var preDefValue = preDefinedValues.find(function (el) {
                        return el.code === preDefDep.code;
                    }) && preDefinedValues.find(function (el) {
                        return el.code === preDefDep.code;
                    }).elements && preDefinedValues.find(function (el) {
                        return el.code === preDefDep.code;
                    }).elements.find(function (el) {
                        return el.code === 'Value';
                    }) && preDefinedValues.find(function (el) {
                        return el.code === preDefDep.code;
                    }).elements.find(function (el) {
                        return el.code === 'Value';
                    }).value;

                    if (preDefDep.value !== preDefValue) {
                        return {
                            v: true
                        };
                    } else {
                        isHidden = false;
                    }
                };

                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = predefinedDependencies[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var preDefDep = _step.value;

                        var _ret = _loop(preDefDep);

                        if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }

            if (runtimeDependencies && runtimeDependencies.length > 0) {
                var _loop2 = function _loop2(runTimeDep) {
                    var runTimeValue = columnsData && columnsData.find(function (el) {
                        return el.code === runTimeDep.code;
                    }) && columnsData.find(function (el) {
                        return el.code === runTimeDep.code;
                    }).elements && columnsData.find(function (el) {
                        return el.code === runTimeDep.code;
                    }).elements.find(function (el) {
                        return el.code === 'Value';
                    }) && columnsData.find(function (el) {
                        return el.code === runTimeDep.code;
                    }).elements.find(function (el) {
                        return el.code === 'Value';
                    }).value;

                    if (runTimeDep.value !== runTimeValue) {
                        return {
                            v: true
                        };
                    } else {
                        isHidden = false;
                    }
                };

                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                    for (var _iterator2 = runtimeDependencies[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var runTimeDep = _step2.value;

                        var _ret2 = _loop2(runTimeDep);

                        if ((typeof _ret2 === 'undefined' ? 'undefined' : _typeof(_ret2)) === "object") return _ret2.v;
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                        }
                    } finally {
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }
            }
        }

        return isHidden;
    };

    var visibleColumnData = columnsData && columnsData.filter(function (_, index) {
        return !checkIsHidden(columnDefinition[index]);
    });

    _react2.default.useEffect(function () {
        var shouldRender = visibleColumnData.length > 0 || tableData.length > 0;
        if (shouldRenderChild && shouldRenderChild[index] !== shouldRender) {
            setShouldRenderChild(function (prevState) {
                return _extends({}, prevState, _defineProperty({}, index, shouldRender));
            });
        }
    }, [visibleColumnData, tableData, shouldRenderChild, index, setShouldRenderChild]);

    return _react2.default.createElement(
        TableContainer,
        { recursive: recursive,
            mobile: mobile,
            tablet: tablet,
            desktop: desktop,
            isErrors: errors && errors.length > 0
        },
        showModal !== null && _react2.default.createElement(_metrixCommon.GenericModal, {
            animate: true,
            visible: true,
            closeEvent: function closeEvent() {
                return setShowModal(null);
            },
            items: _react2.default.createElement(
                _react2.default.Fragment,
                null,
                _react2.default.createElement(_metrixCommon.Header, { size: _metrixCommon.Sizes.md,
                    text: modalDeleteHeader,
                    bottom: _metrixCommon.Sizes.md
                }),
                _react2.default.createElement(_metrixCommon.Label, { text: modalDeleteSubHeader })
            ),
            actionButtons: [{
                text: 'Cancel',
                primary: false,
                clickEvent: function clickEvent() {
                    return setShowModal(null);
                }
            }, {
                text: 'Delete',
                clickEvent: function clickEvent() {
                    setShowModal(null);
                    doSetReturn({
                        actionType: 'deleteInner',
                        componentCode: dotProp,
                        index: showModal
                    });
                    doStep('next');
                },
                primary: true
            }]
        }),
        _react2.default.createElement(_tableHeader2.default, { component: component,
            isCollapsible: isCollapsible,
            isCollapsed: isCollapsed,
            expandHandler: expandHandler,
            'return': props.return,
            reference: reference,
            mobile: mobile,
            tablet: tablet,
            desktop: desktop,
            isErrors: errors && errors.length > 0
        }),
        (!isCollapsed || !isCollapsible) && (visibleColumnData.length > 0 || tableData.length > 0) && (!errors || errors.length === 0) && _react2.default.createElement(
            TableContent,
            null,
            isColumns && columnsData.length > 0 && columnsData.map(function (column, index) {
                if (visibleColumnData.some(function (obj) {
                    return obj.code === column.code;
                }) && (!column.hasOwnProperty('ActuallyIsntHidden') || column.ActuallyIsntHidden !== true)) {
                    doSetReturn({
                        actionType: 'unhide',
                        componentCode: dotProp + '.elements[' + columnsDataIndex + '].elements[' + index + ']',
                        value: true
                    });
                }
                var updColumnDefinition = _extends({}, columnDefinition[index], {
                    legacyCode: columnDefinition[index].code,
                    recursive: true,
                    code: dotProp + '.elements[' + columnsDataIndex + '].elements[' + index + ']'
                });
                var isHidden = checkIsHidden(updColumnDefinition);
                return !isHidden ? _react2.default.createElement(_Component2.default, { component: updColumnDefinition,
                    key: index,
                    'return': column,
                    returns: returns,
                    reference: reference,
                    context: context,
                    doSetReturn: doSetReturn,
                    doStep: doStep,
                    session: session,
                    culture: culture,
                    valid: valid,
                    doReduceDynamicDate: doReduceDynamicDate,
                    configuration: configuration,
                    entity: entity
                }) : null;
            }),
            tableDefinition && _react2.default.createElement(
                _react2.default.Fragment,
                null,
                tableData.length > 0 && tableData.map(function (table, index) {
                    var currentPath = dotProp + '.elements[' + tableDataIndex + '].elements[' + index + ']';

                    var isDynamicRules = table.elements.find(function (el) {
                        return el.code === 'Rules';
                    });
                    var dynamicRules = isDynamicRules && isDynamicRules.elements;
                    var preventDelete = isDynamicRules && dynamicRules.find(function (el) {
                        return el.code === 'PreventDelete';
                    }) && dynamicRules.find(function (el) {
                        return el.code === 'PreventDelete';
                    }).value === 'true';

                    return _react2.default.createElement(
                        TableArea,
                        { key: index },
                        _react2.default.createElement(Divider, null),
                        _react2.default.createElement(WorkflowTable, { component: tableDefinition,
                            'return': table,
                            returns: returns,
                            reference: reference,
                            context: context,
                            doSetReturn: doSetReturn,
                            doStep: doStep,
                            session: session,
                            culture: culture,
                            valid: valid,
                            doReduceDynamicDate: doReduceDynamicDate,
                            configuration: configuration,
                            entity: entity,
                            dotProp: currentPath,
                            index: index,
                            isExpanded: isExpanded,
                            setIsExpanded: setIsExpanded,
                            mobile: mobile,
                            tablet: tablet,
                            desktop: desktop,
                            recursive: true
                        }),
                        allowDelete && !preventDelete && _react2.default.createElement(
                            DeleteButton,
                            { onClick: function onClick() {
                                    return setShowModal(index);
                                } },
                            _react2.default.createElement(_metrixCommon.ClearIcon, { color: _metrixCommon.Colors.StrokeDark })
                        )
                    );
                }),
                allowAdd && (!maxCount || !tableData || tableData.length < maxCount) && _react2.default.createElement(
                    AddButtonContainer,
                    { onClick: function onClick() {
                            doSetReturn({
                                actionType: 'addInner',
                                componentCode: dotProp
                            });
                            doStep('next');
                        }
                    },
                    _react2.default.createElement(_metrixCommon.LinkButton, { text: addButtonLabel || 'Add New' })
                )
            )
        ),
        errors && errors.length > 0 && _react2.default.createElement(
            TableContent,
            null,
            _react2.default.createElement(_metrixCommon.BulletList, { size: _metrixCommon.Sizes.md,
                references: errors,
                color: _metrixCommon.Colors.Error,
                top: _metrixCommon.Sizes.xxs,
                bottom: _metrixCommon.Sizes.xxs
            })
        )
    );
};

WorkflowTable.propTypes = {
    component: _propTypes2.default.object.isRequired,
    return: _propTypes2.default.object.isRequired,
    returns: _propTypes2.default.array.isRequired,
    reference: _propTypes2.default.object.isRequired,
    context: _propTypes2.default.object.isRequired,
    doSetReturn: _propTypes2.default.func.isRequired,
    doStep: _propTypes2.default.func.isRequired,
    session: _propTypes2.default.object.isRequired,
    culture: _propTypes2.default.object.isRequired,
    configuration: _propTypes2.default.object.isRequired,
    entity: _propTypes2.default.object.isRequired,
    valid: _propTypes2.default.bool.isRequired,
    doReduceDynamicDate: _propTypes2.default.func.isRequired,
    dotProp: _propTypes2.default.string.isRequired,
    index: _propTypes2.default.number.isRequired,
    isExpanded: _propTypes2.default.bool.isRequired,
    setIsExpanded: _propTypes2.default.func.isRequired,
    mobile: _propTypes2.default.bool.isRequired,
    tablet: _propTypes2.default.bool.isRequired,
    desktop: _propTypes2.default.bool.isRequired,
    recursive: _propTypes2.default.bool,
    shouldRenderChild: _propTypes2.default.array,
    setShouldRenderChild: _propTypes2.default.func
};

exports.default = WorkflowTable;